import BaseAvatar from "./BaseAvatar.vue";
export default BaseAvatar;
